export const validationEmail = (value) => {
  if (value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/)) {
    return true;
  } else {
    return false;
  }
};

export const validationVin = (value) => {
  if(value.length !== 17) {
    return false;
  } else {
    return true;
  }
}

export const validationPassword = (value) => {
  if (
    value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}[!@#$%^&*]$/)
  ) {
    return true;
  } else {
    return false;
  }
};

export const validationRepeatPassword = (newPassword, repeatPassword) => {
  if(newPassword.length !== 0 && repeatPassword.length !== 0 && newPassword === repeatPassword) {
    return true;
  } else {
    return false;
  }
}

export const validationField = (value) => {
  if(value.length >= 3) {
    return true;
  } else {
    return false;
  }
}

export const validationVinInfo = (value) => {
  if(value.length === undefined) {
    return false;
  } else {
    return true;
  }
}

export const validationPhone = (value) => {
  if(value.length === 14) {
    return true;
  } else {
    return false;
  }
}
